import {useEffect, useState} from "react";

export function useLocalStorageState(initialState, key) {
    const [value, setValue] = useState(function() {
        return JSON.parse(localStorage.getItem(key)) ?? initialState;
    });

    useEffect(function(){
        localStorage.setItem("watched", JSON.stringify(value));
    }, [value, key])

    return [value, setValue];
}